import { ArticlesBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { isAppInPDFMode } from "src/utils/rendering";
import { EmptyStateCard } from "src/components/EmptyState/EmptyStateCard";

import { ArticlesSectionProps } from "./types";
import { ArticleProps } from "@foodpilot/foods";
import { useTokenResolver } from "../../fields/extensions/typingSuggestions/hooks/useTokenResolver";

export const ArticlesSection = (props: ArticlesSectionProps) => {
    const { articles } = props;
    const { t } = useTranslation();

    const shouldHideButtons =
        isAppInPDFMode() ||
        (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("from") === "templates");

    const { processToken } = useTokenResolver(3);
    const [processedArticles, setProcessedArticles] = useState<ArticleProps[]>([]);

    useEffect(() => {
        if (!articles) return;

        const processed = articles.map((article, index) => ({
            title: processToken(article.title),
            description: processToken(article.description),
            imageSrc: article.imageSrc,
            isFirst: index === 0,
            readMoreText: shouldHideButtons ? "" : t("glossary.read_more", "Read more"),
        }));

        setProcessedArticles(processed);
    }, [articles, processToken, shouldHideButtons, t]);

    if (!articles?.length) {
        return (
            <EmptyStateCard
                title={t("cms.articles.empty.title", "No articles yet")}
                description={t("cms.articles.empty.description", "Articles will appear here once they are added.")}
            />
        );
    }

    return (
        <ArticlesBox
            articles={processedArticles}
            sxProps={{
                "& .MuiTypography-root": {
                    overflowWrap: "anywhere",
                    "& a": {
                        wordBreak: "break-all",
                        color: "primary.main",
                        "&:visited": {
                            color: "primary.main",
                        },
                    },
                },
                ...(shouldHideButtons && {
                    "& .MuiButton-root": {
                        display: "none",
                    },
                    "& .MuiLink-root": {
                        pointerEvents: "none",
                        cursor: "default",
                    },
                }),
            }}
        />
    );
};
